import { PreviewCard } from '@components/shared/PreviewCard'
import { currencyMask } from '@utils/masks/currencyMask'
import { AccountBalanceWallet } from '@assets/svgs/AccountBalanceWallet'
import { TrendingUp } from '@assets/svgs/TrendingUp'
import { InfoIcon } from '@assets/svgs/InfoIcon'
import { CurrencyDollarSimple } from '@assets/svgs/CurrencyDollarSimple'
import type { BudgetPreviewsClientProps } from './types'

export const BudgetPreviewsClient = ({ budget, grossRevenue, netRevenue }: BudgetPreviewsClientProps) => {
  return [
    <PreviewCard
      isBudget
      label="Budget"
      value={currencyMask(budget.toFixed(2))}
      icon={<AccountBalanceWallet />}
      bottomText="Orçamento aprovado"
    />,
    <PreviewCard
      label="Faturamento Bruto"
      value={currencyMask(grossRevenue.toFixed(2))}
      icon={<CurrencyDollarSimple />}
      infoIcon={<InfoIcon />}
    />,
    <PreviewCard label="Faturamento Líquido" value={currencyMask(netRevenue.toFixed(2))} icon={<TrendingUp />} />
  ]
}
